import {FC, useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep4: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {watch, reset, setValue} = useFormContext()
  // const [timer, setTimer] = useState(10)

  // useEffect(() => {
  //   // Start the timer countdown when the component mounts
  //   const intervalId = setInterval(() => {
  //     setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0))
  //   }, 1000)

  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId)
  // }, [])

  const errorCheck = useWatch({name: 'errorCheck'})

  const operationType = useWatch({name: 'operationType'})
  // useEffect(() => {
  //   // Perform an action when the timer reaches 0
  //   if (timer === 0) {
  //     // Assuming you have access to stepper.current in the scope of this component
  //     // Replace this with your actual logic to go to step 1
  //     setValue('fromFinish', true)
  //     goToStep(2)
  //     // goToFirstStep()
  //   }
  // }, [timer])
  return (
    <div className='w-100'>
      {/* <div className='mt-3 mb-8'>
        <p>Tiempo restante: {timer} segundos</p>
      </div> */}
      {errorCheck ? (
        <div className='d-flex justify-content-center flex-column align-items-center'>
          <div>
            <img alt='Exito' src={toAbsoluteUrl('/media/logos/close.png')} />
          </div>
          <div className='d-flex flex-column align-items-center mt-3'>
            <div className='fs-1 fw-bolder'>{`Hubo un error al hacer ${
              operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
            }`}</div>
          </div>
        </div>
      ) : (
        <div className='d-flex justify-content-center flex-column align-items-center'>
          <div>
            <img alt='Exito' src={toAbsoluteUrl('/media/logos/check.png')} />
          </div>
          <div className='d-flex flex-column align-items-center mt-3'>
            <div className='fs-1 fw-bolder'>Éxito</div>
            <div className='fs-3 fw-bolder'>{`${
              operationType === 'checkin' ? 'CheckIn' : 'CheckOut'
            } exitoso`}</div>
            <div className='fs-4 fw-bolder'>{`Su Información ha sido grabada con éxito`}</div>
          </div>
        </div>
      )}
      <div className='d-flex flex-stack pt-15 justify-content-end'>
        <button type='button' className='btn btn-lg btn-primary me-3' onClick={() => goToStep(1)}>
          Finalizar
        </button>
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div>
  )
}

export {FormStep4}
